// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-black{\n    position: relative;\n    height: 7px;\n    width: 300px;\n    background: #0C0F11;\n}", "",{"version":3,"sources":["webpack://src/components/Shared/Line/LineBlack.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".line-black{\n    position: relative;\n    height: 7px;\n    width: 300px;\n    background: #0C0F11;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
